import React from "react";
import { TriangleAlert } from "lucide-react";
import { MyTooltip } from "./MyTooltip";
import "./EscalationIndicator.css";

type EscalationIndicatorProps = {
  size?: number;
  strokeWidth?: number;
  tooltipPlacement?: "top" | "bottom" | "left" | "right";
};

export const EscalationIndicator: React.FC<EscalationIndicatorProps> = ({
  size = 16,
  strokeWidth = 2,
  tooltipPlacement = "top",
}) => {
  return (
    <MyTooltip title="Required Escalation" placement={tooltipPlacement}>
      <div className="escalation-indicator">
        <TriangleAlert size={size} strokeWidth={strokeWidth} />
      </div>
    </MyTooltip>
  );
};
